<template>
  <div class="new-folder">
    <!-- 新建文件夹 -->
    <!-- <el-button class="table_header_btn" v-if="showBut"
      size="medium">新建文件夹</el-button> -->
    <!-- <div class="add_new_btn" @click="dialogTableVisible = true"> <i class="el-icon-plus"></i> 新建文件夹</div> -->
    <el-dialog title="新建文件夹" :visible.sync="dialogTableVisible" width="500px" class="main_dialog">
      <el-form @submit.native.prevent :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="新建文件夹:" prop="name">
          <el-input v-model="formData.name" @keyup.enter.native="newFolder"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer"> -->
        <el-button class="dialog_confirm" size="small" @click="newFolder">确 定</el-button>
        <el-button class="dialog_cancel" size="small" @click="dialogTableVisible = false">关闭</el-button>
      <!-- </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { folderCreate } from "@/api/material";
export default {
  name: "NewFolder",
  props: {
    activeID: {
      type: Number,
      default: 0,
    },
    showBut: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogTableVisible: false,
      formData: {
        name: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入文件夹名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    newFolder() {
      folderCreate({parent_id: this.activeID, name: this.formData.name}).then((res) => {
        this.$emit("update");
        this.dialogTableVisible = false;
        this.$message({
          message: res.msg,
          type: res.code == 200 ? "success" : "error",
        });
        this.formData.name = "";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-folder {
  // margin-right: 24px;
  // display: inline-block;
  .table_header_btn {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 4px;
    background: var(--work-color);
    color: #ffffff;
    &.is-disabled {
      filter: opacity(0.6);
    }
  }
}
</style>
